<template>
  <div class="home-div">
    <SideBar />
    <div class="markdown-container">
      <div class="container mbl-no-hover">
        <div class="sub-input">
          <!-- 第一行：省、市、主题、日期 -->
          <div><input class="title-inp" v-model="province" placeholder="输入省"></div>
          <div><input class="title-inp" v-model="city" placeholder="输入市"></div>
          <div><input class="title-inp" v-model="travelTitle" placeholder="输入主题"></div>
          <div>
            <el-date-picker
              v-model="travelTime"
              type="date"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              class="title-inp date-picker"
              :editable="false"
            >
            </el-date-picker>
          </div>
          
          <!-- 操作按钮区域 -->
          <div class="action-buttons">
            <el-button class="editor-btn indent-btn" @click="insertIndent">
              <i class="el-icon-edit"></i>
              <span>缩进</span>
            </el-button>

            <el-button class="editor-btn media-btn" @click="showMediaDialog">
              <i class="el-icon-video-camera"></i>
              <span>插入音视频</span>
            </el-button>
            <el-button class="editor-btn submit-btn" type="primary" @click="submit">
              <i class="el-icon-upload2"></i>
              <span>提交</span>
            </el-button>
          </div>
        </div>

        <!-- 显示封面图片预览（如果已设置） -->
        <div v-if="travelImg" class="cover-preview-area">
          <div class="cover-preview-label">
            <i class="el-icon-picture-outline"></i>
            <span>游记封面（第一张上传的图片）</span>
          </div>
          <div class="cover-preview-img">
            <img :src="travelImg" alt="游记封面">
          </div>
        </div>

        <mavon-editor 
          v-model="travelDesc" 
          ref="md" 
          @imgAdd="$imgAdd" 
          @change="change" 
          style="min-height: 600px" 
        />

      </div>
    </div>
    <BottomTip />

    <!-- 媒体对话框 (保持不变) -->
    <el-dialog 
      :title="mediaForm.type === 'video' ? '插入视频' : '插入音频'" 
      :visible.sync="mediaDialogVisible" 
      :width="dialogWidth"
      class="media-dialog"
      :before-close="handleClose">
      
      <div class="media-dialog-content">
        <div class="media-type-switch">
          <div class="type-card" :class="{active: mediaForm.type === 'video'}" @click="mediaForm.type = 'video'">
            <i class="el-icon-video-play"></i><span>视频</span>
          </div>
          <div class="type-card" :class="{active: mediaForm.type === 'audio'}" @click="mediaForm.type = 'audio'">
            <i class="el-icon-headset"></i><span>音频</span>
          </div>
        </div>

        <div class="url-input-area">
          <div class="input-label"><i class="el-icon-upload"></i><span>本地上传</span></div>
          
          <el-upload
            class="upload-file"
            drag
            action="#"
            :http-request="customUpload"
            :before-upload="handleBeforeUpload"
            :auto-upload="true"
            :show-file-list="false"
            accept="video/*,audio/*">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">点击或拖拽文件上传</div>
          </el-upload>

          <div v-if="uploadProgress > 0" style="margin-top:10px">
            <el-progress :percentage="uploadProgress" status="success" />
          </div>
        </div>

        <div class="url-input-area">
          <div class="input-label"><i class="el-icon-link"></i><span>或使用网络链接</span></div>
          <el-input v-model="mediaForm.url" placeholder="输入视频/音频链接" clearable>
            <template slot="prepend">https://</template>
          </el-input>
        </div>

        <div class="preview-area" v-if="uploadSuccessUrl">
          <div class="preview-label"><i class="el-icon-view"></i><span>上传成功</span></div>
          <div class="preview-content">
            <i class="el-icon-success" style="color:#409EFF;font-size:22px"></i>
            &nbsp;已准备就绪
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="mediaDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="insertMedia">插入到编辑器</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SideBar from '@/components/menu/SideBar.vue';
import BottomTip from '@/components/menu/BottomTip.vue';
import axios from "axios";
import config from '@/utils/Config.js';
import { Message } from 'element-ui';
import { pubTravel } from '@/api/travels.js';

export default {
  name: 'PubTravels',
  components: { SideBar, BottomTip },
  data() {
    return {
      province: "",
      city: "",
      travelTitle: "",
      travelDesc: "",
      travelTime: "", // 日期字段
      travelImg: "", // 存储第一次上传的图片路径
      isFirstImageUploaded: false, // 标记是否已经上传过第一张图片
      mediaDialogVisible: false,
      mediaForm: { type: 'video', url: '' },
      uploadSuccessUrl: '',
      uploadProgress: 0
    };
  },
  computed: {
    dialogWidth() {
      return window.innerWidth <= 768 ? '90%' : '500px';
    }
  },
  methods: {
    change(value, render) {
      this.html = render;
    },
    showMediaDialog() {
      this.mediaForm = { type: 'video', url: '' };
      this.uploadSuccessUrl = '';
      this.uploadProgress = 0;
      this.mediaDialogVisible = true;
    },
    handleBeforeUpload(file) {
      const isMedia = file.type.startsWith('video/') || file.type.startsWith('audio/');
      if (!isMedia) {
        Message.error('只能上传视频或音频');
        return false;
      }
      return true;
    },
    customUpload(options) {
      let file = options.file;
      let formdata = new FormData();
      formdata.append("file", file);
      this.uploadProgress = 0;

      axios({
        url: config.BASE_URL + config.uploadLifeFileUrl,
        method: "post",
        data: formdata,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progress) => {
          let percent = Math.round((progress.loaded / progress.total) * 100);
          this.uploadProgress = percent;
        }
      }).then(resp => {
        const url = config.BASE_FILE_URL + resp.data.msg;
        this.uploadSuccessUrl = url;
        this.mediaForm.url = url;
        Message.success("上传成功！");
      }).catch(() => {
        Message.error("上传失败");
        this.uploadProgress = 0;
      });
    },
    insertMedia() {
      const url = this.uploadSuccessUrl || this.mediaForm.url;
      if (!url) {
        Message.warning('请上传或输入地址');
        return;
      }
      let code = '';
      if (this.mediaForm.type === 'video') {
        code = `<video width="100%" height="auto" src="${url}" controls></video>`;
      } else {
        code = `<audio src="${url}" controls></audio>`;
      }
      this.travelDesc += '\n' + code + '\n';
      this.mediaDialogVisible = false;
      Message.success('已插入编辑器');
    },
    insertIndent() {
      this.travelDesc += '&emsp;&emsp;';
      Message.success('已插入缩进');
    },
    
    // 改造图片上传方法：第一次上传时保存为 travelImg
    $imgAdd(pos, $file) {
      var formdata = new FormData();
      formdata.append("file", $file);
      
      axios({
        url: config.BASE_URL + config.uploadTravelFileUrl,
        method: "post",
        data: formdata,
        headers: { "Content-Type": "multipart/form-data" }
      }).then(resp => {
        const url = config.BASE_FILE_URL + resp.data.msg;
        
        // 关键逻辑：如果是第一次上传图片，保存为 travelImg
        if (!this.isFirstImageUploaded && !this.travelImg) {
          this.travelImg = url;
          this.isFirstImageUploaded = true;
          Message.success(`封面图片已保存：${url.substring(url.lastIndexOf('/') + 1)}`);
          // 可选：提示用户第一张图片已设为封面
          this.$message({
            message: '第一张图片已自动设置为游记封面',
            type: 'success',
            duration: 3000
          });
        } else {
          // 后续上传的图片只插入到编辑器，不覆盖封面
          Message.success('图片已插入编辑器');
        }
        
        // 将图片插入到编辑器
        this.$refs.md.$img2Url(pos, url);
      }).catch(() => {
        Message.error("图片上传失败");
      });
    },
    
    handleClose(done) { done(); },
    async submit() {
      // 更新验证逻辑，包含必填字段和封面图片
      if (!this.province || !this.city || !this.travelTitle || !this.travelTime || !this.html) {
        this.$message.error("省、市、主题、日期、内容不能为空！");
        return;
      }
      
      if (!this.travelImg) {
        this.$message.error("请先在编辑器中上传一张图片作为游记封面！");
        return;
      }
      
      // 构建提交的数据对象，包含封面图片路径
      const dto = { 
        province: this.province,
        city: this.city,
        travelTitle: this.travelTitle,
        travelTime: this.travelTime,
        travelDesc: this.html,
        travelImg: this.travelImg  // 传递第一次上传的图片路径
      };
      
      const resp = await pubTravel(dto);
      if (resp.code === 200) {
        this.$message.success("提交成功");
        // 清空表单
        this.province = "";
        this.city = "";
        this.travelTitle = "";
        this.travelTime = "";
        this.travelDesc = "";
        this.travelImg = "";
        this.isFirstImageUploaded = false;
        this.html = "";
      }
    }
  }
};
</script>

<style scoped>
@media only screen and (max-width: 768px) {
  .sub-input { width:100%; flex-direction:column; gap:15px; }
  .sub-input input { width:100%; max-width:100%; }
  .action-buttons { width:100%; justify-content:space-between; }
  .action-buttons .el-button { flex:1; margin-left:0 !important; }
  .cover-preview-img img { max-width: 100%; height: auto; }
}
.sub-input { width:100%; display:flex; justify-content:space-between; align-items:center; margin-top:20px; margin-bottom:5px; color:var(--font-color-1); flex-wrap:wrap; gap:15px; }
.sub-input input { width:400px; height:50px; padding:0 15px; font-size:16px; border:2px solid #e1e8ed; border-radius:8px; transition:all 0.3s ease; outline:none; color:var(--font-color-1); background:var(--bg-color-1); }
.sub-input input:focus { border-color:#409EFF; box-shadow:0 0 0 2px rgba(64,158,255,0.1); }
.action-buttons { display:flex; gap:10px; }
.editor-btn { height:40px; padding:0 20px; border-radius:20px; display:inline-flex; align-items:center; gap:6px; transition:all 0.3s ease; }
.editor-btn i { font-size:16px; }

/* 日期选择器样式 */
.date-picker {
  width: 180px;
}
.date-picker >>> .el-input__inner {
  height: 50px;
  line-height: 50px;
  border: 2px solid #e1e8ed;
  border-radius: 8px;
}
.date-picker >>> .el-input__inner:focus {
  border-color: #409EFF;
  box-shadow: 0 0 0 2px rgba(64,158,255,0.1);
}

/* 封面图片预览区域样式 */
.cover-preview-area {
  margin: 15px 0;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e1e8ed;
}

.cover-preview-label {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #409EFF;
}

.cover-preview-label i {
  font-size: 16px;
}

.cover-preview-img {
  text-align: center;
}

.cover-preview-img img {
  max-width: 300px;
  max-height: 180px;
  border-radius: 8px;
  border: 2px solid #409EFF;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.indent-btn {
  background: #f5aa39;
  border-color: #f5aa39;
  color: white;
}
.indent-btn:hover {
  background: #f7b85c;
  border-color: #f7b85c;
  transform:translateY(-1px);
  box-shadow:0 4px 8px rgba(245,170,57,0.2);
}
.media-btn { background:#67C23A; border-color:#67C23A; color:white; }
.media-btn:hover { background:#85ce61; border-color:#85ce61; transform:translateY(-1px); box-shadow:0 4px 8px rgba(103,194,58,0.2); }
.submit-btn { background:#409EFF; border-color:#409EFF; }
.submit-btn:hover { background:#66b1ff; border-color:#66b1ff; transform:translateY(-1px); box-shadow:0 4px 8px rgba(64,158,255,0.2); }
.markdown-container { width:90%; margin-left:5%; margin-right:5%; }
.title-inp { margin-right:10px; }
.home-div { width:100%; height:100%; margin:0; padding-top:80px; padding-bottom:10px; overflow: hidden;}
.media-dialog >>> .el-dialog { border-radius:16px; overflow:hidden; }
.media-dialog >>> .el-dialog__header { background:linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding:20px; margin:0; }
.media-dialog >>> .el-dialog__title { color:white; font-weight:500; font-size:18px; }
.media-dialog >>> .el-dialog__headerbtn .el-dialog__close { color:white; }
.media-dialog >>> .el-dialog__body { padding:24px; }
.media-dialog-content { display:flex; flex-direction:column; gap:24px; }
.media-type-switch { display:flex; gap:16px; justify-content:center; }
.type-card { flex:1; display:flex; flex-direction:column; align-items:center; padding:16px; background:#f8f9fa; border-radius:12px; cursor:pointer; transition:all 0.3s ease; border:2px solid transparent; }
.type-card i { font-size:28px; margin-bottom:8px; color:#909399; }
.type-card span { font-size:14px; color:#606266; font-weight:500; }
.type-card:hover { background:#ecf5ff; transform:translateY(-2px); }
.type-card.active { border-color:#409EFF; background:#ecf5ff; }
.type-card.active i,.type-card.active span { color:#409EFF; }
.url-input-area { background:#f8f9fa; padding:16px; border-radius:12px; }
.input-label { display:flex; align-items:center; gap:6px; margin-bottom:12px; font-weight:500; color:#606266; }
.input-label i { font-size:16px; color:#409EFF; }
.upload-file { width:100%; text-align:center; padding:20px; border:1px dashed #dcdfe6; border-radius:8px; }
.preview-area { background:#f8f9fa; padding:16px; border-radius:12px; }
.preview-label { display:flex; align-items:center; gap:6px; margin-bottom:12px; font-weight:500; color:#606266; }
.preview-content { background:#ffffff; border:2px dashed #dcdfe6; border-radius:8px; padding:20px; text-align:center; }
.dialog-footer { display:flex; justify-content:flex-end; gap:12px; }
</style>